export default __webpack_public_path__ + "static/media/phoenix-business-bg.7abcc37b.jpeg";